export default "__VITE_ASSET__DmL4aGw$__"